import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

class ViewCodeItem extends Component {
  state = {
    chkValue: false,
  };
  _checkChange = (e) => {
    ////console.log(e)
    const { chkValue } = this.state;
    const { viewCode, viewCodeAdd, viewCodeDel } = this.props.childProps;

    if (!chkValue) {
      viewCodeAdd(viewCode);
      //TagSearchList 함수 Props로 받아서 "202007|202001" 형식으로 만들어 보낼것.
    } else {
      viewCodeDel(viewCode);
      //해당 코드 삭제.
    }

    this.setState({
      chkValue: !chkValue,
    });
  };
  render() {
    const { chkValue } = this.state;
    const { viewCode, viewName, init } = this.props.childProps;
    return (
      <Fragment>
        <dd>
          <div className="chek_group">
            <input
              name="선택"
              id={`checkbox_${viewCode}`}
              type="checkbox"
              value=""
              checked={init ? false : chkValue}
              className="checkbox_img"
              onChange={this._checkChange}
            />
            <label htmlFor={`checkbox_${viewCode}`}>{viewName}</label>
          </div>
        </dd>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ViewCodeItem));
